import _Input from "@alifd/next/es/input";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import React, { PureComponent } from 'react';
import './index.less';
var TextAreaSetter = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(TextAreaSetter, _PureComponent);
  function TextAreaSetter() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;
    _this.state = {
      setterValue: null
    };
    return _this;
  }
  var _proto = TextAreaSetter.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      _onChange = _this$props.onChange,
      placeholder = _this$props.placeholder,
      value = _this$props.value;
    return /*#__PURE__*/React.createElement(_Input.TextArea, {
      value: value || '',
      onChange: function onChange(val) {
        return _onChange(val);
      },
      placeholder: placeholder,
      style: {
        width: '100%'
      }
    });
  };
  return TextAreaSetter;
}(PureComponent);
TextAreaSetter.defaultPorps = {
  onChange: function onChange() {
    return undefined;
  },
  value: undefined,
  defaultValue: null,
  placeholder: '请输入'
};
TextAreaSetter.displayName = 'TextAreaSetter';
export { TextAreaSetter as default };